import i18n from '@/utils/i18n';

const filters =
  [
    {
      "name": "title",

      "placeholder": i18n.t('form.title_placeholder'),
      "value": "",
      "type": "text",
      "label": i18n.t('form.title'),
      "main": false
    },
    {
      "name": "key",
      "placeholder": i18n.t('form.key_placeholder'),
      "value": "",
      "type": "text",
      "label": i18n.t('form.key'),
      "main": false
    },
    {
      "name": "content.price",
      "type": "price-range",
      "main": false,
      "label": i18n.t('form.price_range'),
      options: [
        {
          placeholder: i18n.t('form.from'),
          name: "from"
        },
        {
          placeholder: i18n.t('form.to'),
          name: "to"
        }
      ]
    },
    {
      "name": "contentTypes.id",
      "type": "select",
      "label": i18n.t('form.content_type'),
      searchable: true,
      "multiple": false,
      group: false,
      "options_url": "content-types?limit=50",
      placeholder: i18n.t('transactions.type_to_search'),
      filter_field: 'key',
      "main": false
    },
    {
      "name": "content.created_at",
      "type": "date",
      "label": i18n.t('form.created_at'),
      "main": false,
      isRange: true,
      mode: 'date',
    },
  ];

export default filters
